"use client";

import * as React from "react";

import { cn } from "@/src/lib/utils/cn";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, type = "button", ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn("auth-button", className)}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";
